import { adminHttpClient } from '../commons/adminHttpClient'

const inviteEligibleEmployee = (userId: string): Promise<any> => {
  return adminHttpClient.put(`/Companies/InviteEligibleEmployee/${userId}`, null)
}

export default inviteEligibleEmployee
